import PropTypes from "prop-types";
import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuth from "../hooks/useAuth";
// pages
import Login from "../pages/auth/Login";

import LoadingScreen from "../components/LoadingScreen";

AuthGuard.propTypes = {
  children: PropTypes.node,
};

export const origin = {
  // "http://localhost:3000": "",
  "https://partner-dev.woxa.com": "https://partner-dev.woxa.com/sign-in/",
  "https://partner.woxa.com": "https://partner.woxa.com/sign-in/",
};

export default function AuthGuard({ children }) {
  const { isAuthenticated, isInitialized } = useAuth();

  const { pathname } = useLocation();

  const [requestedLocation, setRequestedLocation] = useState(null);
  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    // if (!window.location.origin.includes('http://localhost:3000')) {
    //   window.location.replace(origin[window.location.origin])
    // }
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
